
<header>
  <div class="d-flex">
    <fieldmagic-dialog-title
      icon="plus-circle"
      class="text-primary"
      label="{{ strViewType == 'edit' ? 'edit' : 'add' }}"
    ></fieldmagic-dialog-title>
    <div class="ml-auto d-flex">
      <ul class="list-inline pull-right">
        <li class="list-inline-item">
          <button (click)="preSaveRecurringJob()" class="btn ml-1 btn-primary" [disabled]="bSubmitted || (disabledSaveButton$ | async)">
            <fa-icon *ngIf="!bSubmitted" [icon]="['fas', 'save']"></fa-icon>
            <fa-icon *ngIf="bSubmitted" [icon]="['fas', 'spinner']" [spin]="true" aria-hidden="true"></fa-icon>
            <span class="pl-1">{{ 'save' | translate }}</span>
          </button>
        </li>
        <li class="list-inline-item">
          <fieldmagic-primary-button
            (click)="cancelDialog()"
            icon="times"
            variant="error"
            label="close"
            [disabled]="bSubmitted"
          ></fieldmagic-primary-button>
        </li>
      </ul>
    </div>
  </div>
</header>

<hr class="separator"/>

<mat-dialog-content *ngIf="recurringJobForm" class="mobile-view-dialog">
<app-error-handler onlyFor="edit_form" [isAction]="true" alignment="center" (onError)="onFormError()">
<div *ngIf="recurringJobForm.length != 0; else noJobForm" class="mt-3">
  <ul class="nav nav-tabs" id="myTab" role="tablist">
    <li *ngFor="let item of recurringJobForm" class="nav-item text-size">
      <a class="nav-link" [ngClass]="{'active': recurringJobForm[0]['label'] === item.label}" id="{{item.label}}-tab" data-toggle="tab" href="#{{item.id}}" role="tab" aria-selected="true" translate>{{ item.label }}</a>
    </li>
  </ul>
  <div class="tab-content">
    <div *ngFor="let item of recurringJobForm" [ngClass]="{'active': recurringJobForm[0]['label'] === item.label, 'show': recurringJobForm[0]['label'] === item.label}" class="tab-pane row p-4" [id]="item.id" role="tabpanel">
      <form *ngIf="item.groups" [formGroup]="item.groups">
        <div class="row">
          <ng-container *ngFor="let data of item.fields">
            <div [ngClass]="
            {'col-2': arCustomColumn.indexOf(data.label) > -1,
            'col-6': arCustomColumn.indexOf(data.label) < 0 && data.space === 6,
            'col-12': arCustomColumn.indexOf(data.label) < 0 && data.space === 12
            }"
            class="mb-3">
              <ng-container>
                <app-edit-field [item]="data" [form]="item.groups" [bSubmitted]="bSubmitted" [strMode]="strViewType" strModule="recurring_jobs" [strRecordId]="" (parentEvent)="onChangeFormField($event, data.key)"></app-edit-field>
                <ng-template *ngIf="data.key === 'assets_items' then lineItems"></ng-template>
                <ng-template *ngIf="data.key === 'work_order_items' then workOrderItems"></ng-template>
                <ng-template *ngIf="data.key === 'material_line_items' then materialLineItems"></ng-template>

              </ng-container>
            </div>
            <ng-template #lineItems>
              <ng-container>
                <div class="row content_padding">
                  <table class="table border-left border-right border-bottom mb-0" width="100%">
                    <thead>
                      <tr>
                        <th scope="col" width="15%" class="font-12">{{ 'asset_type' | translate }}</th>
                        <th scope="col" width="14%" class="font-12">{{ 'asset_tag' | translate }}</th>
                        <th *ngIf="bDepartmentTracking" scope="col" width="15%" class="font-12">{{ 'department' | translate }}</th>
                        <th scope="col" width="15%" class="font-12">{{ 'price_per_asset' | translate }}</th>
                        <th scope="col" width="20%" class="font-12">{{ 'time_per_asset' | translate }}</th>
                        <th scope="col" width="1%"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngIf="arLineAttributes.length < 1">
                        <td colspan="6" class="text-center">
                          <span>{{ 'no_available_items' | translate }}</span>
                        </td>
                      </tr>
                      <ng-container *ngFor="let attr of arLineAttributes; index as i">
                        <tr>
                            <td scope="row">
                              <div class="p-2">
                                <ng-select
                                  [items]="attr['asset_type_obv'] | async"
                                  [typeahead]="attr['asset_type_typehead']"
                                  [loading]="attr['asset_type_loader']"
                                  [clearable]="true"
                                  [ngModelOptions]="{standalone: true}"
                                  bindLabel="text"
                                  bindValue="id"
                                  [(ngModel)]="attr['data']['asset_type_id']"
                                  [id]="attr['id'] + 'asset_type'"
                                  [name]="attr['id'] + 'asset_type'"
                                  (change)="assetTypeChange($event, i)"
                                  (open)="getRelatedData('asset_types', 'asset_type', i)"
                                  appendTo="body">
                                </ng-select>
                              </div>
                            </td>
                            <td>
                              <div class="p-2">
                                <ng-select
                                  [items]="attr['asset_tags_obv'] | async"
                                  [typeahead]="attr['asset_tags_typehead']"
                                  [loading]="attr['asset_tags_loader']"
                                  [clearable]="true"
                                  bindLabel="text"
                                  [bindValue]
                                  [ngModelOptions]="{standalone: true}"
                                  [(ngModel)]="attr['asset_tags']"
                                  [id]="attr['id'] + 'asset_tags'"
                                  [name]="attr['id'] + 'asset_tags'"
                                  [maxSelectedItems]="10"
                                  [multiple]="true"
                                  (open)="getRelatedData('tags', 'asset_tags', i)"
                                  (change)="tagsChange($event, i)"
                                  appendTo="body">
                                </ng-select>
                              </div>
                            </td>
                            <td *ngIf="bDepartmentTracking">
                              <div class="p-2">
                                <ng-select
                                  [items]="attr['department_obv'] | async"
                                  [typeahead]="attr['department_typehead']"
                                  [loading]="attr['department_loader']"
                                  [clearable]="true"
                                  [ngModelOptions]="{standalone: true}"
                                  bindLabel="text"
                                  bindValue="id"
                                  [(ngModel)]="attr['data']['department_id']"
                                  [id]="attr['id'] + 'department'"
                                  [name]="attr['id'] + 'department'"
                                  (open)="getRelatedData('departments', 'department', i)"
                                  appendTo="body">
                                </ng-select>
                              </div>
                            </td>
                            <td>
                              <div class="p-2">
                                <fc-currency-input
                                  [places]="4"
                                  [(ngModel)]="attr['data']['price_per_asset']"
                                  [ngModelOptions]="{standalone: true}"
                                  [nonNegative]="false"
                                  [customClass]="'form-control font-size-12 input-height-40'"
                                  min="0"
                                  step ="0.01"
                                  disableScroll>
                                </fc-currency-input>
                              </div>
                            </td>
                            <td>
                              <div class="p-2">
                                <input
                                  [(ngModel)]="attr['data']['time_per_asset']"
                                  [ngModelOptions]="{standalone: true}"
                                  type="number"
                                  class="form-control font-size-11 input-height-40"
                                  [maxLength]="(item.max_length) ? item.max_length : '16'"
                                  [ngModelOptions]="{standalone: true}"
                                  disableScroll
                                  >
                              </div>
                            </td>
                            <td class="w-10 text-center">
                              <button
                                id="add_additional_code_{{ i }}"
                                type="button"
                                class="btn btn-link text-success"
                                (click)="addAssetAttribute()"
                                matTooltip="{{ 'add_item' | translate }}">
                                <fa-icon [icon]="['fal', 'plus-circle']"></fa-icon>
                              </button>
                              <button
                                id="remove_additional_code_{{ i }}"
                                type="button"
                                class="btn btn-link text-danger"
                                (click)="removeAssetAttribute(i)"
                                matTooltip="{{ 'remove' | translate }}">
                                <fa-icon [icon]="['fal', 'minus-circle']"></fa-icon>
                              </button>
                            </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </ng-container>
            </ng-template>

            <ng-template #workOrderItems>
              <ng-container>
                <app-jobs-work-order-items
                  class="row"
                  [asChild]="true"
                  [initialValue]="initialWorkOrder$ | async"
                  (updated)="onWorkOrderUpdate($event)"
                  [parentWasValidated]="wasValidated$ | async"
                  [defaultTaxCode]="defaultTaxCode$ | async"
                  [defaultDepartment]="defaultDepartment$ | async"
                  [defaultPricebook]="defaultPricebook$ | async"
                >
                </app-jobs-work-order-items>
              </ng-container>
            </ng-template>
            <ng-template #materialLineItems>
              <material-lines
                [initialValue]="initialMaterials$ | async"
                (updated)="onMaterialsUpdate($event)"
              >
              </material-lines>
            </ng-template>
          </ng-container>
        </div>
      </form>
    </div>
  </div>
</div>
<ng-template #noJobForm>
  <div class="col-12 text-center">
    <fa-icon [icon]="['fas', 'spinner']" class="loading-spinner" [spin]="true"></fa-icon>
  </div>
</ng-template>
</app-error-handler>
</mat-dialog-content>

